import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import Table from 'components/Table';
import Money from 'components/Money';

import {
  RefundRow,
  InvoiceRow,
  PaymentRow,
  CreditNoteRow,
  OverpaymentRow,
  DraftInvoiceRow
} from './components';

import syncIcon from './assets/refresh.svg';

import './styles.css';

const getScheduleRow = (element, index, handleRowClick, scheduleType) => {
  switch (element.type) {
    case 'invoice':
      return (
        <InvoiceRow
          key={index}
          invoice={element}
          scheduleType={scheduleType}
          handleRowClick={handleRowClick}
        />
      );
    case 'draft_invoice':
      return (
        <DraftInvoiceRow
          key={index}
          draftInvoice={element}
          scheduleType={scheduleType}
          handleRowClick={handleRowClick}
        />
      );
    case 'payment':
      return (
        <PaymentRow
          key={index}
          payment={element}
          scheduleType={scheduleType}
          handleRowClick={handleRowClick}
        />
      );
    case 'credit_note':
      return (
        <CreditNoteRow
          key={index}
          creditNote={element}
          scheduleType={scheduleType}
          handleRowClick={handleRowClick}
        />
      );
    case 'overpayment':
      return (
        <OverpaymentRow
          key={index}
          overpayment={element}
          scheduleType={scheduleType}
          handleRowClick={handleRowClick}
        />
      );
    case 'refund':
      return (
        <RefundRow
          key={index}
          refund={element}
          scheduleType={scheduleType}
          handleRowClick={handleRowClick}
        />
      );
    default:
      return null;
  }
};

const ExtraOptions = ({children, className}: any) => (
  <div className={classNames(className, 'ExtraOptions')}>{children}</div>
);

class Schedule extends React.Component<any> {
  static ExtraOptions = ExtraOptions;

  render() {
    const {data, handleRowClick, children, scheduleType} = this.props;

    return (
      !_.isEmpty(data) && (
        <div className="Schedule">
          <Table>
            <Table.Header>
              <Table.HeaderItem heading="Date" className="date" />
              <Table.HeaderItem heading="Due date" className="dueDate" />
              <Table.HeaderItem heading="Activity" className="activity" />
              <Table.HeaderItem heading="Details" className="details" />
              <Table.HeaderItem heading="Status" className="status" />
              <Table.HeaderItem
                className="syncIcon"
                heading={<img src={syncIcon} alt="Synced with Xero" />}
              />
              <Table.HeaderItem heading="Due" className="due" />
              <Table.HeaderItem heading="Payment" className="payment" />
              <Table.HeaderItem heading="Balance" className="balance" />
            </Table.Header>
            <Table.Body>
              {data.schedule.map((element, index) =>
                getScheduleRow(element, index, handleRowClick, scheduleType)
              )}
              <Table.Row className="balances">
                <Table.Cell />
                <Table.Cell />
                <Table.Cell />
                <Table.Cell className="detailsCell" />
                <Table.Cell />
                <Table.Cell />
                <Table.Cell>
                  <Money amount={_.get(data, 'totals.totalDue')} semibold />
                </Table.Cell>
                <Table.Cell>
                  <Money
                    amount={_.get(data, 'totals.totalReceived')}
                    semibold
                  />
                </Table.Cell>
                <Table.Cell>
                  <Money amount={_.get(data, 'totals.totalBalance')} semibold />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          {children}
        </div>
      )
    );
  }
}

export default Schedule;
